import { Pipe, Inject, LOCALE_ID, NgModule } from '@angular/core';
import { DateModel, DateHelper, DateConstant, StringHelper } from '@colibrium/abp-base';
import { formatNumber } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
import * as ɵngcc0 from '@angular/core';
class AbpCapitalizeFirstPipe {
    //#region model properties
    //#endregion model properties
    //#region public functions
    /**
     * transforms string to first letter capital
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        if (!value) {
            return '';
        }
        if (value.length > 1) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
        else {
            return value.charAt(0).toUpperCase();
        }
    }
}
AbpCapitalizeFirstPipe.ɵfac = function AbpCapitalizeFirstPipe_Factory(t) { return new (t || AbpCapitalizeFirstPipe)(); };
AbpCapitalizeFirstPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "abp-capitalize-first", type: AbpCapitalizeFirstPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpCapitalizeFirstPipe, [{
        type: Pipe,
        args: [{
                name: 'abp-capitalize-first'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpDateFormatPipe {
    constructor() {
        //#region model properties
        //#region model properties
        this.dateModel = new DateModel();
        //#endregion private functions
    }
    //#endregion model properties
    //#region public functions
    /**
     * trasforms input value
     * @param {?} value
     * @param {?} dateFormat
     * @return {?}
     */
    transform(value, dateFormat) {
        this.resetValues();
        if (value) {
            this.dateModel = DateHelper.getDatePartInfo(dateFormat);
            if (this.dateModel && this.dateModel.hasValue()) {
                return this.getFormattedValue(value);
            }
        }
        return '';
    }
    //#endregion public functions
    //#region private functions
    /**
     * resets values
     * @private
     * @return {?}
     */
    resetValues() {
        this.dateModel = new DateModel();
    }
    /**
     * gets formatted value
     * @private
     * @param {?} inputValue
     * @return {?}
     */
    getFormattedValue(inputValue) {
        /** @type {?} */
        let formattedValue = '';
        if (inputValue) {
            /** @type {?} */
            let matchArr = [];
            if (this.dateModel.seperator == DateConstant.dateSeperator.space) {
                matchArr = inputValue.match(DateConstant.regexExp.alphanumeric);
            }
            else {
                matchArr = inputValue.match(DateConstant.regexExp.numericOnly);
            }
            /** @type {?} */
            let filteredDateValue = '';
            if (matchArr && matchArr.length > 0) {
                filteredDateValue = StringHelper.toSafeTrim(matchArr.join(''));
            }
            if (filteredDateValue) {
                if (this.dateModel.datePartSorted) {
                    /** @type {?} */
                    let datePartCurrentLen = 0;
                    for (let i = 0; i < this.dateModel.datePartSorted.length; i++) {
                        /** @type {?} */
                        let isLast = (i == this.dateModel.datePartSorted.length - 1);
                        if (this.dateModel.monthModel.index == i) {
                            this.setMonthValue(filteredDateValue, this.dateModel.monthModel, datePartCurrentLen);
                        }
                        else {
                            this.setDatePartValue(filteredDateValue, this.dateModel.datePartSorted[i], datePartCurrentLen, isLast);
                        }
                        datePartCurrentLen = datePartCurrentLen + this.dateModel.datePartSorted[i].maxLength;
                        if (this.dateModel.datePartSorted[i].value) {
                            formattedValue = `${formattedValue}${this.getDatePartFormattedValue(this.dateModel.datePartSorted[i], isLast)}`;
                        }
                    }
                }
            }
        }
        return formattedValue;
    }
    /**
     * gets datepart formatted value
     * @private
     * @param {?} datePart
     * @param {?=} isLast
     * @return {?}
     */
    getDatePartFormattedValue(datePart, isLast = false) {
        /** @type {?} */
        let formattedValue = '';
        if (datePart && datePart.formattedValue) {
            formattedValue = datePart.formattedValue;
            if (!isLast && datePart.formattedValue.length == datePart.maxLength) {
                formattedValue = `${formattedValue}${this.dateModel.seperator}`;
            }
        }
        return formattedValue;
    }
    /**
     * sets month value
     * @private
     * @param {?} inputValue
     * @param {?} datePartModel
     * @param {?=} priorDatePartLength
     * @return {?}
     */
    setMonthValue(inputValue, datePartModel, priorDatePartLength = 0) {
        /** @type {?} */
        let monthPartValue = datePartModel.index == 0 ? inputValue : inputValue.substring(priorDatePartLength, inputValue.length);
        if (monthPartValue.length > 0) {
            if (datePartModel.maxLength == 4 && !monthPartValue.startsWith('ju')) {
                datePartModel.maxLength = 3;
            }
            else if (datePartModel.maxLength == 9) {
                /** @type {?} */
                let months = Object.values(DateConstant.monthName);
                for (let i = 0; i < months.length; i++) {
                    if (months[i].startsWith(monthPartValue.substring(0, 2).toLowerCase())) {
                        datePartModel.maxLength = months[i].length;
                        break;
                    }
                }
            }
            this.setDatePartValue(inputValue, datePartModel, priorDatePartLength);
        }
    }
    /**
     * sets date part model value
     * @private
     * @param {?} inputValue
     * @param {?} datePartModel
     * @param {?=} priorDatePartLength
     * @param {?=} isLast
     * @return {?}
     */
    setDatePartValue(inputValue, datePartModel, priorDatePartLength = 0, isLast = false) {
        if (inputValue && datePartModel) {
            /** @type {?} */
            let end = priorDatePartLength + datePartModel.maxLength;
            if (isLast || inputValue.length < priorDatePartLength + datePartModel.maxLength) {
                end = inputValue.length;
            }
            datePartModel.value = inputValue.substring(priorDatePartLength, end);
            //verify if date part is valid
            /** @type {?} */
            let isValid = false;
            /** @type {?} */
            let matches = datePartModel.value.match(datePartModel.regexMath);
            if (matches && matches.length > 0) {
                datePartModel.value = matches.join('');
                //check for valid month codes/names
                if (datePartModel.duration == DateConstant.duration.months && datePartModel.maxLength > 2) {
                    /** @type {?} */
                    let months = datePartModel.maxLength == 3 ? Object.keys(DateConstant.monthName) : Object.values(DateConstant.monthName);
                    for (let i = 0; i < months.length; i++) {
                        if (months[i].startsWith(datePartModel.value.toLowerCase())) {
                            datePartModel.maxLength = months[i].length;
                            isValid = true;
                            break;
                        }
                    }
                }
                else {
                    isValid = true;
                }
            }
            if (isValid &&
                datePartModel.formattedValue.length == datePartModel.maxLength) {
                switch (datePartModel.duration) {
                    case DateConstant.duration.days:
                        isValid = this.isValidDay();
                        break;
                    case DateConstant.duration.years:
                        isValid = this.isValidYear();
                        break;
                    case DateConstant.duration.months:
                        isValid = this.isValidMonth();
                        break;
                }
            }
            else if (datePartModel.formattedValue.length > datePartModel.maxLength) {
                isValid = false;
            }
            if (!isValid) {
                datePartModel.value = '';
            }
        }
    }
    /**
     * determines if year is valid
     * @private
     * @return {?}
     */
    isValidYear() {
        return DateHelper.isValidYear(this.dateModel.yearModel.value);
    }
    /**
     * determines if month is valid
     * @private
     * @return {?}
     */
    isValidMonth() {
        /** @type {?} */
        let isValid = true;
        //if dd mm yyyy, check validity w.r.t date
        if (this.dateModel.dayModel.index == 0) {
            isValid = this.isValidDay();
            //for dd mm yyyy - year will not be entered first. hence bypassing 29 rule
            if (!isValid && !this.dateModel.yearModel.value) {
                isValid = this.dateModel.dayModel.value.toString() == '29';
            }
        }
        return isValid && DateHelper.isValidMonth(this.dateModel.monthModel.value);
    }
    /**
     * determines if day is valid
     * @private
     * @return {?}
     */
    isValidDay() {
        return DateHelper.isValidDay(this.dateModel.dayModel.value, this.dateModel.monthModel.value, this.dateModel.yearModel.value);
    }
}
AbpDateFormatPipe.ɵfac = function AbpDateFormatPipe_Factory(t) { return new (t || AbpDateFormatPipe)(); };
AbpDateFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "abp-date-format", type: AbpDateFormatPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpDateFormatPipe, [{
        type: Pipe,
        args: [{
                name: "abp-date-format"
            }]
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AbpDateFormatPipe.prototype.dateModel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpPipeConstant {
}
AbpPipeConstant.is_Not_a_Number = 'is not a number';
AbpPipeConstant.zero = '0';
AbpPipeConstant.one = '1';
AbpPipeConstant.three = '3';
AbpPipeConstant.hyphen = '-';
AbpPipeConstant.dot = '.';
if (false) {
    /** @type {?} */
    AbpPipeConstant.is_Not_a_Number;
    /** @type {?} */
    AbpPipeConstant.zero;
    /** @type {?} */
    AbpPipeConstant.one;
    /** @type {?} */
    AbpPipeConstant.three;
    /** @type {?} */
    AbpPipeConstant.hyphen;
    /** @type {?} */
    AbpPipeConstant.dot;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpDecimalFormatPipe {
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} localeID
     */
    constructor(localeID) {
        this.localeID = localeID;
    }
    //#endregion constructor
    //#region public functions
    /**
     * tranfroms given deimal value to given format
     * @param {?} value The number to be formatted
     * @param {?=} minIntegerDigits
     * @param {?=} minFractionDigits
     * @param {?=} maxFractionDigits
     * @param {?=} locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * @return {?}
     */
    transform(value, minIntegerDigits, minFractionDigits, maxFractionDigits, locale) {
        if (value) {
            locale = locale || this.localeID;
            /** @type {?} */
            const digitsInfo = this.getDigitsInfo(minIntegerDigits, minFractionDigits, maxFractionDigits);
            /** @type {?} */
            const num = this.strToNumber(value);
            return formatNumber(num, locale, digitsInfo);
        }
        return '';
    }
    //#endregion public functions
    //#region private functions
    /**
     * transforms a string into a number (if needed).
     * @private
     * @param {?} value
     * @return {?}
     */
    strToNumber(value) {
        // Convert strings to numbers
        if (typeof value === 'string' && !isNaN(Number(value) - parseFloat(value))) {
            return Number(value);
        }
        if (typeof value !== 'number') {
            throw new Error(`${value} is not a number`);
        }
        return value;
    }
    /**
     * returns digits info
     * @private
     * @param {?=} minIntegerDigits
     * @param {?=} minFractionDigits
     * @param {?=} maxFractionDigits
     * @return {?}
     */
    getDigitsInfo(minIntegerDigits, minFractionDigits, maxFractionDigits) {
        minIntegerDigits = (/** @type {?} */ (minIntegerDigits)) || AbpPipeConstant.one;
        minFractionDigits = (/** @type {?} */ (minFractionDigits)) || AbpPipeConstant.zero;
        maxFractionDigits = (/** @type {?} */ (minIntegerDigits)) || AbpPipeConstant.three;
        return `${minIntegerDigits}${AbpPipeConstant.dot}${minFractionDigits}${AbpPipeConstant.hyphen}${maxFractionDigits}`;
    }
}
AbpDecimalFormatPipe.ɵfac = function AbpDecimalFormatPipe_Factory(t) { return new (t || AbpDecimalFormatPipe)(ɵngcc0.ɵɵdirectiveInject(LOCALE_ID)); };
AbpDecimalFormatPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "decimalformat", type: AbpDecimalFormatPipe, pure: true });
/** @nocollapse */
AbpDecimalFormatPipe.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpDecimalFormatPipe, [{
        type: Pipe,
        args: [{
                name: "decimalformat"
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    AbpDecimalFormatPipe.prototype.localeID;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion components
//#region directives
//#endregion directives
//#region pipes/filter
//#endregion pipes/filters
//#region services
//#endregion services
//#region handlers/providers
//#endregion handlers/providers
class AbpPipeModule {
}
AbpPipeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpPipeModule });
AbpPipeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpPipeModule_Factory(t) { return new (t || AbpPipeModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpPipeModule, { declarations: [AbpCapitalizeFirstPipe, AbpDateFormatPipe, AbpDecimalFormatPipe], exports: [AbpCapitalizeFirstPipe, AbpDateFormatPipe, AbpDecimalFormatPipe] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpPipeModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    AbpCapitalizeFirstPipe,
                    AbpDateFormatPipe,
                    AbpDecimalFormatPipe
                ],
                exports: [
                    AbpCapitalizeFirstPipe,
                    AbpDateFormatPipe,
                    AbpDecimalFormatPipe
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpCapitalizeFirstPipe, AbpDateFormatPipe, AbpDecimalFormatPipe, AbpPipeModule };

//# sourceMappingURL=colibrium-abp-pipe.js.map